import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconReport12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconReport12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 1h7a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5M1 1.5A1.5 1.5 0 0 1 2.5 0h7A1.5 1.5 0 0 1 11 1.5v9A1.5 1.5 0 0 1 9.5 12h-7A1.5 1.5 0 0 1 1 10.5zM3.91 3a.5.5 0 0 0 0 1h4.363a.5.5 0 0 0 0-1zm-.5 2.5a.5.5 0 0 1 .5-.5h2.908a.5.5 0 0 1 0 1H3.91a.5.5 0 0 1-.5-.5m2.302 1.838L5.364 7l-.348.338L3.58 8.73a.5.5 0 0 0 .696.717l1.087-1.054L6.45 9.447l.349.338.348-.338L8.58 8.055a.5.5 0 0 0-.696-.717L6.8 8.392z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconReport12);
